module.exports = __webpack_public_path__ + "img/horizontal_6_2_9006.44ab0e11.png";